import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/logo.jpeg";

const WelcomeComp = () => {
  const [userData, setUserData] = useState({
    name: "Kullanıcı",
    tasksCount: 0,
    totalRevenue: 0,
    isLoading: true,
    roleTitle: "İş Ortağı"
  });

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const userName = authUser?.AD_SOYAD || "Kullanıcı";
        
        // 📌 YENİ: Token'ı alıyoruz (Hem authUser içinden hem de doğrudan token olarak kaydettiysen oradan)
        const token = localStorage.getItem("token") || authUser?.Token;
        
        const isAdmin = authUser?.HESAP_TURU === 'Admin'; 

        if (!userId || !token) {
          setUserData(prev => ({ ...prev, isLoading: false }));
          return;
        }

        // --- 1. TAMAMLANAN SİPARİŞ SAYISI ---
        const taskFilter = isAdmin
          ? "TESLIMAT_DURUMU eq 'Tamamlandı'"
          : `TESLIMAT_DURUMU eq 'Tamamlandı' and SATICI_ID eq ${userId}`;

        // 📌 YENİ: İsteğe headers eklendi
        const resTasks = await fetch(`https://harmanappapi.stechomeyazilim.info/SIPARIS_TESLIMATLARI?$filter=${taskFilter}&$select=ID`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        
        const dataTasks = await resTasks.json();
        const completedCount = dataTasks.value ? dataTasks.value.length : 0;

        // --- 2. KAZANÇ / CİRO ÇEKME (ODEME tablosundan) ---
        const odemeFilter = isAdmin ? "" : `$filter=SIPARIS/SATICI_ID eq ${userId}&`;
        
        // 📌 YENİ: İsteğe headers eklendi
        const resOdeme = await fetch(`https://harmanappapi.stechomeyazilim.info/ODEME?${odemeFilter}$select=ODEME_MIKTARI`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });

        const dataOdeme = await resOdeme.json();

        const totalRevenue = dataOdeme.value
          ? dataOdeme.value.reduce((acc, curr) => acc + (curr.ODEME_MIKTARI || 0), 0)
          : 0;

        setUserData({
          name: userName,
          tasksCount: completedCount,
          totalRevenue: totalRevenue,
          isLoading: false,
          roleTitle: isAdmin ? "Sistem Yöneticisi" : (authUser?.HESAP_TURU === 'Satıcı' ? "Satıcı İş Ortağı" : "Alıcı")
        });

      } catch (error) {
        console.error("Özet veriler çekilirken hata:", error);
        setUserData(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchUserStats();
  }, []);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Tekrar Hoş Geldiniz !</h5>
                <p>{isAdmin ? "Yönetim Paneli Özeti" : "HarmanaGEL Paneli"}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={avatar1}
                  alt="Profil"
                  className="img-thumbnail "
                />
              </div>
              <h5 className="font-size-15 text-truncate">{userData.name}</h5>
              <p className="text-muted mb-0 text-truncate">{userData.roleTitle}</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : userData.tasksCount}
                    </h5>
                    <p className="text-muted mb-0">{isAdmin ? "Tamamlanan Sipariş" : "Tamamlanan Sipariş"}</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : `${userData.totalRevenue.toLocaleString("tr-TR")} TL`}
                    </h5>
                    <p className="text-muted mb-0">{isAdmin ? "Toplam Ciro (TL)" : "Toplam Kazanç (TL)"}</p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link
                    to={isAdmin ? "/contacts-list" : "/hesabim"}
                    className="btn btn-primary btn-sm"
                  >
                    {isAdmin ? "Kullanıcıları Yönet" : "Profili Görüntüle"} <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default WelcomeComp;